export const PAGES_URLS = {
    INFO_SOUND: "https://wiki.athomearticulation.com/athomearticulationknowledgebase/speech-sound-screener",
};
